"use client";
import React from "react";

interface EventDateTimeProps {
  date?: string;
  time?: string;
}

const EventDateTime: React.FC<EventDateTimeProps> = ({ date, time }) => {
  return (
    <div className="relative md:block block">
      <div
        className="flex items-center md:gap-12 2xl:px-32 md:px-32 md:py-2 gap-4 px-4 py-2 text-white md:text-[20px] text-[14px] font-semibold"
        style={{
          borderRadius: "6px",
          border: "1px solid rgba(255, 255, 255, 0.09)",
          background: "rgba(255, 255, 255, 0.12)",
          backdropFilter: "blur(6px)",
        }}
      >
        <p className="text-white">{date}</p>
        <p className="opacity-60">|</p>
        <p>{time}</p>
      </div>
    </div>
  );
};

export default EventDateTime;
